/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Cron_CustomInputs */

const cs_field_cron_custom = /** @type {(inputs: Field_Cron_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastní cron`)
};

const en_field_cron_custom = /** @type {(inputs: Field_Cron_CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom cron`)
};

/**
* | output |
* | --- |
* | "Custom cron" |
*
* @param {Field_Cron_CustomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_cron_custom = /** @type {((inputs?: Field_Cron_CustomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Cron_CustomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_cron_custom(inputs)
	return cs_field_cron_custom(inputs)
});